import { Status } from "@/models/status";
import { Pagination } from "@/models/pagination";
import { IStatus, StatusState } from "@/types/status";
import { GeneralMutationTree } from "../generalMutation";

const mutations: GeneralMutationTree<StatusState, IStatus> = {
  single: (state, single) => {
    state.single = new Status(single);
  },
  pagination: (state, pagination) => {
    pagination.data = pagination.data.map((item) => new Status(item));
    state.pagination = new Pagination(pagination);
  },
  clear: (state) => {
    state.single = new Status();
    state.pagination = new Pagination();
  },
};

export default mutations;
